import React from 'react';

const Flag = ({ code }) => {
    if (!code) return null;
    return (
        <img 
            src={`https://flagcdn.com/w20/${code.toLowerCase()}.png`} 
            alt={`${code} flag`} 
            style={{ marginRight: '0.5rem' }} 
        />
    );
};

export default Flag;